var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlugNoChange(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 12V17C27 21.418 23.418 25 19 25H18V27C18 28.105 17.105 29 16 29C14.895 29 14 28.105 14 27V25H13C8.582 25 5 21.418 5 17V12H27ZM8 10V5C8 3.895 8.895 3 10 3C11.105 3 12 3.895 12 5V10H8ZM20 5C20 3.895 20.895 3 22 3C23.105 3 24 3.895 24 5V10H20V5Z",
    fill: "#ECECEC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27 12V17C27 21.418 23.418 25 19 25H18V27C18 28.105 17.105 29 16 29C14.895 29 14 28.105 14 27V25H13C8.582 25 5 21.418 5 17V12H27ZM8 10V5C8 3.895 8.895 3 10 3C11.105 3 12 3.895 12 5V10H8ZM20 5C20 3.895 20.895 3 22 3C23.105 3 24 3.895 24 5V10H20V5Z",
    fill: "#ECECEC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlugNoChange);
export default __webpack_public_path__ + "static/media/plug-no-change.f732bcab920f9417354b9056cec21453.svg";
export { ForwardRef as ReactComponent };